import * as Yup from 'yup';
import { useMemo } from 'react';
import { SuccessStory } from '../../../@types/successStory';

// The fields the form can show an API validation message on (SS-1).
export const STORY_FORM_FIELDS = ['name', 'name_ar', 'title', 'title_ar', 'story', 'story_ar', 'images', 'type', 'date'];

// The form values of a story. No `order`: positions are set with the arrows on
// the Stories / Activities tabs (PUT /success-stories/reorder), and a new story
// is appended at the end of its type by the API.
export const storyFormValues = (story?: SuccessStory) => ({
  name: story?.name || '',
  name_ar: story?.name_ar || '',
  title: story?.title || '',
  title_ar: story?.title_ar || '',
  story: story?.story || '',
  story_ar: story?.story_ar || '',
  active: story?.active ?? true,
  images: story?.images || [],
  type: story?.type || 'story',
  date: story?.date ? String(story.date).slice(0, 10) : '',
});

export const SuccessStorySchema = (currentStory?: SuccessStory) => {
  const NewSuccessStorySchema = Yup.object().shape({
    name: Yup.string().min(2).required('Name is required'),
    name_ar: Yup.string(),
    title: Yup.string(),
    title_ar: Yup.string(),
    story: Yup.string().min(3).required('Story is required'),
    story_ar: Yup.string(),
    active: Yup.boolean(),
    images: Yup.array().of(Yup.string()),
    type: Yup.string().oneOf(['story', 'activity']),
    date: Yup.string(),
  });

  const defaultValues: any = useMemo(() => storyFormValues(currentStory), [currentStory]);

  return { NewSuccessStorySchema, defaultValues };
};
